import { useMutation, useQueryClient } from "@tanstack/react-query";
import { updateBettingSelection } from "@/api/bettingSelections";
import { BettingSelectionsQueryKeys } from "@/tanstackQuery/queries/bettingSelections";
import { UpdateBettingSelectionParams } from "@/types/ApiResponses/BettingSelection";

export const useUpdateBettingSelection = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (params: UpdateBettingSelectionParams) => updateBettingSelection(params),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [BettingSelectionsQueryKeys.BettingSelections] });
    },
  });
};
